import { lazyLoad } from 'utils/loadable';

export const EntityQuantityReportPage = lazyLoad(
  () => import('./index'),
  module => module.EntityQuantityReportPage
);
